import React from 'react';

const LogonContext = React.createContext();

export default LogonContext;